export default __webpack_public_path__ + "static/media/13_4_0.c6ae8eb6.png";